import { gql } from "@apollo/client";

export const UPDATE_FOLDER_EXTERNAL_CHECK_RESULT = gql`
  mutation updateFolderExternalCheckResult($folderExternalCheck: FolderExternalCheckInput!) {
    updateFolderExternalCheckResult(folderExternalCheck: $folderExternalCheck) {
      correlationId
    }
  }
`;
